module.exports = __webpack_public_path__ + "img/pin_not_open.1fdc3d01.png";